import * as React from "react";
import { FC, useState } from "react";
import { useHistory, Link } from 'react-router-dom';
import axios from "axios";
import defaults from "../../constants/defaults";

interface Props {
  campaign: any;
  ap: any;
  postBalance: () => any;
  deviceId: any;
  band: string;
  survey_ids: any;
  search: string;
  token: string;
  user: any;
  threshold: number;
  userData: any;
  skip_seconds: number;
  each_seconds: number;
  bc_seconds: number;
  gads_seconds: number;
  test: boolean;
}

export const NewBanner: FC<Props> = ({ campaign, ap, postBalance, deviceId, band, survey_ids, search, token, user, threshold, userData, skip_seconds, each_seconds, bc_seconds, gads_seconds, test }) => {
  let history = useHistory();
  const _captureBannerClick = async () => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    const fields = {
      AccessPointID: ap.ap_mac,
      LocationID: Number(ap.ap_locationid),
      DeviceID,
      CampaignID: campaign.CampaignID,
      MediaType: "click",
    };
    try {
      if(!test) {
        await axios.post("/impressions", { fields });
      }
      //await postBalance(campaign, "click");
    } catch (err) {
      console.log("error posting /campaigns on deal item click");
    }
  };

  return (
    <div className="row w-100 m-0">
    
    <Link
      className="col-11 card m-0  flex-row  align-items-center"
      style={{
        boxShadow: "0px 6px 26px 1px rgba(0,0,0,0.13)",
        color: "black",
        height: "6.8em",
        backgroundImage: `url(/google-storage/${encodeURIComponent(campaign.CampaignDealItemURL)})`,
        backgroundPosition: "center",
        backgroundSize: "cover"
      }}
      onClick={() => _captureBannerClick()}
      to={{
        pathname: gads_seconds === 0 ? "/newdescription" : "/adgoogle",
        campaign: campaign,
        DeviceID: deviceId,
        ap,
        band,
        survey_ids,
        search: search,
        token: token,
        threshold,
        userData,
        skip_seconds,
        each_seconds,
        bc_seconds,
        gads_seconds
      }}
    >     
     
    </Link>
    <div className="col-1 m-0 p-0">
      <button className="btn btn-lg btn-danger w-100" 
          style={{
            height: "100%",
            textAlign: "center",
            padding: 0,
            borderRadius: "0px 20px 20px 0px"
          }}>&raquo;</button>
      </div>
    </div>
  );
};
